
































































import { Prop, Component, Vue } from "vue-property-decorator";
import formatDate from "@/helpers/formatDate.ts";
import { Project } from "@/api/project-api";
import { Answer, deleteAnswer, getAnswers, newAnswer } from "@/api/minutes-api";
import VDelete from "@/components/VDelete.vue";

@Component({
  components: {
    VDelete
  }
})
export default class MinuteShowPage extends Vue {
  @Prop({ required: true }) projectId!: string;
  @Prop({ required: true }) answerId!: string;

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  get project(): Project | null {
    return this.$store.state.project;
  }

  textOmit(text: string) {
    if (text.length > 100) {
      return text;
    } else {
      return text;
    }
  }

  canRemoveMinutes() {
    return (
      this.permissions.includes("project/document_secret") ||
      this.permissions.includes("service/project_operation")
    );
  }

  canEditMinutes() {
    return (
      this.permissions.includes("service/project_operation") ||
      this.permissions.includes("project/minutes_operation")
    );
  }

  stringDate() {
    return formatDate(new Date(this.answer.updated));
  }
  showAnswer(skip: boolean, secret: boolean) {
    if (skip) return false;
    else if (secret === true) {
      return !this.permissions.includes("project/minutes_read");
    } else {
      return true;
    }
  }
  async remove() {
    if (!this.answer) return;
    await deleteAnswer(this.answerId);
    this.goListPage();
  }
  goListPage() {
    const params = {
      projectId: this.projectId
    };
    this.$router.push({ name: "minute-list", params });
  }
  goEditPage() {
    const params = {
      projectId: this.projectId,
      answerId: this.answerId
    };
    this.$router.push({ name: "minute-edit", params });
  }

  private answer: Answer = newAnswer();
  private answers: Answer[] = [];

  private async created() {
    this.initAnswers();
  }
  private async initAnswers() {
    const entries = await getAnswers(this.projectId);
    this.answers = entries;
    this.answer = this.answers.find(
      r => String(r.id) === String(this.answerId)
    ) as Answer;
  }
}
